class ShareLinks {
    constructor (context, settings, $, WindowPopup, $socialLinksSelector) {
        // Environment variables
        this.context = context;
        this.settings = settings;
        this.$ = $;

        this.$socialLinksSelector = $socialLinksSelector;

        if (this.$socialLinksSelector.length > 0) {
            $('body').on('click', this.$socialLinksSelector, function (e) {
                e.preventDefault();

                WindowPopup($(this).attr('href'), 500, 300);
            });
        }
    }
}

export default ShareLinks;
